var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { useContext, useEffect, useState } from 'react';
import { fetchSvgFromUrl, getIconUrlFromName, updateSVGAttributes } from '../components/dynamic-svg/DynamicSvgCommonUtils';
import { getDynamicSvgProps } from '../components/dynamic-svg/DynamicSvgStyles';
import { StateConfigContext } from '../providers';
window.__TEMPICONS__ = {};
export var useDynamicSvgWeb = props => {
  var stateContext = useContext(StateConfigContext);
  var dynamicSvgProps = getDynamicSvgProps(props, stateContext);
  var _dynamicSvgProps$xml = dynamicSvgProps.xml,
    _xml = _dynamicSvgProps$xml === void 0 ? '' : _dynamicSvgProps$xml,
    color = dynamicSvgProps.color,
    svgUrl = dynamicSvgProps.svgUrl,
    iconName = dynamicSvgProps.iconName,
    onError = dynamicSvgProps.onError,
    restProps = __rest(dynamicSvgProps, ["xml", "color", "svgUrl", "iconName", "onError"]);
  var _useState = useState(null),
    iconUrl = _useState[0],
    setIconUrl = _useState[1];
  var _useState2 = useState(_xml),
    xml = _useState2[0],
    setXml = _useState2[1];
  useEffect(() => {
    if (iconName) {
      setIconUrl(getIconUrlFromName(iconName));
    }
  }, [iconName]);
  useEffect(() => {
    if (iconUrl || svgUrl) {
      if (!window.__TEMPICONS__[iconName]) {
        window.__TEMPICONS__[iconName] = new Promise(res => {
          res(fetchSvgFromUrl(svgUrl || iconUrl));
        }).then(res => {
          setXml(res);
          return res;
        }).catch(err => onError && onError(err));
      } else {
        window.__TEMPICONS__[iconName].then(res => {
          setXml(res);
        }).catch(err => onError && onError(err));
      }
    }
  }, [iconUrl, svgUrl]);
  return Object.assign(Object.assign({}, restProps), {
    xml: updateSVGAttributes(xml, color),
    fill: color,
    color
  });
};